import { render, staticRenderFns } from "./Delivery_List.vue?vue&type=template&id=1bba6322&scoped=true&"
import script from "./Delivery_List.vue?vue&type=script&lang=js&"
export * from "./Delivery_List.vue?vue&type=script&lang=js&"
import style0 from "./Delivery_List.vue?vue&type=style&index=0&id=1bba6322&scoped=true&lang=css&"
import style1 from "./Delivery_List.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bba6322",
  null
  
)

export default component.exports